/**
 * @generated SignedSource<<c6b6a8b5428ee3ecdf9fa11bae857bc0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateRelationshipTypeCriteriaInput = {
  clientMutationId?: string | null | undefined;
  relationshipTypeIds?: ReadonlyArray<any | null | undefined> | null | undefined;
};
export type useRelationshipTypeCriteriaMutation$variables = {
  input: UpdateRelationshipTypeCriteriaInput;
};
export type useRelationshipTypeCriteriaMutation$data = {
  readonly updateRelationshipTypeCriteria: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useRelationshipTypeCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useRelationshipTypeCriteriaMutation = {
  response: useRelationshipTypeCriteriaMutation$data;
  variables: useRelationshipTypeCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRelationshipTypeCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateRelationshipTypeCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateRelationshipTypeCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useRelationshipTypeCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useRelationshipTypeCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateRelationshipTypeCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateRelationshipTypeCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "RelationshipTypeCriterionConnection",
                    "kind": "LinkedField",
                    "name": "relationshipTypeCriteria",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RelationshipTypeCriterion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "relationshipTypeId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "relationshipTypeCriteria(orderBy:[\"RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f026cd2b6c7f4cdf22ccaed4899928e9",
    "id": null,
    "metadata": {},
    "name": "useRelationshipTypeCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation useRelationshipTypeCriteriaMutation(\n  $input: UpdateRelationshipTypeCriteriaInput!\n) {\n  updateRelationshipTypeCriteria(input: $input) {\n    query {\n      ...useRelationshipTypeCriteria_query\n      id\n    }\n  }\n}\n\nfragment useRelationshipTypeCriteria_query on Query {\n  currentUser {\n    relationshipTypeCriteria(orderBy: [RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC]) {\n      nodes {\n        relationshipTypeId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac69e5ec1edad5f35cce7b8c621f465b";

export default node;
